import { CmsObjectWithDefault } from '@components/Cms/types';

export type ForgotPasswordEmailFormCmsKey =
    | 'invalidEmailValidationMessage'
    | 'unableToResetPasswordMessage'
    | 'resetPasswordSuccessMessage'
    | 'pleaseTryAgain'
    | 'completeCaptcha';
export const ForgotPasswordEmailFormCmsWithDefault: CmsObjectWithDefault<ForgotPasswordEmailFormCmsKey> = {
    invalidEmailValidationMessage: {
        cmsId: 76303,
        defaultTranslation: 'Please enter a valid email address.',
    },
    unableToResetPasswordMessage: {
        cmsId: 76314,
        defaultTranslation: 'There was an issue resetting your password. Please try again.',
    },
    resetPasswordSuccessMessage: {
        cmsId: 76317,
        defaultTranslation: 'The link to reset your password has been sent to {0}. Please check your mail.',
    },
    pleaseTryAgain: {
        cmsId: 269092,
        defaultTranslation: 'Sorry, we have encountered a technical issue. Please try again.',
    },
    completeCaptcha: {
        cmsId: 67538,
        defaultTranslation: 'Please complete the captcha (above).',
    },
};
